<template>
  <div
    :class="[
      'border border-solid border-faint-grey rounded',
      'px-2 pb-2 pt-1',
      'flex flex-col'
    ]"
  >
    <template v-for="(child, pos) in value.children">
      <label v-if="debug" class="text-danger font-bold" :key="pos">{{ pos }} - {{ child.name }}</label>
      <template v-if="!child.component">
        <div
          v-show="shouldShow(child.name)"
          v-if="!isSubField(child)"
          :key="child.name"
          style="margin-left: -1.5rem; margin-right: -1.5rem;"
          :class="[
            'border-solid border-t-0 border-r-0 border-l-0 border-b border-faint-grey my-1 shadow-drop'
          ]"
        />
        <transition :key="child.name" name="fade">
          <formulate-field-adapter
            @mounted="emitField"
            :disabled="disabled"
            v-show="shouldShow(child.name)"
            :class="{
              'mb-2': !isSubField(value.children[pos+1]),
            }"
            :key="child.name"
            :field="child"
          />
        </transition>
      </template>
      <component
        v-else
        :key="child.name"
        :is="child.component"
      >
        <div v-html-safe="child.children"/>
      </component>
    </template>
  </div>
</template>

<script>
import FormulateFieldAdapter from './FormulateFieldAdapter.vue'

export default {
  components: { FormulateFieldAdapter },
  props: {
    value: {
      default: () => ({}),
      type: Object
    },
    showCriteria: {
      default: () => ({}),
      type: Object
    },
    debug: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitField(fieldName, fieldVm) {
      this.$emit('mounted-field', fieldName, fieldVm)
    },
    shouldShow(id) {
      return this.showCriteria && this.showCriteria[id]
    },
    isSubField(field) {
      return (
        field &&
        'render_params' in field &&
        field.render_params &&
        'show_when' in field.render_params && this._.isString(field.render_params.show_when)
      )
    }
  }
}
</script>

<style>

</style>
